export default __webpack_public_path__ + "static/media/flower.c4d5fd22.jpg";